import propTypes from 'prop-types';
import { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const Step = ({ step, title, children }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="step">
        <div className="header">
          <div className="number">{step}</div>
          <h5 className="title">{title}</h5>
        </div>
        <div className="content">{children}</div>
      </div>
      <style jsx>{`
        .header {
          display: flex;
          align-items: center;
        }
        .number {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          width: 40px;
          background-color: ${theme.colors.primary};
          border: 2px solid ${theme.colors.primarypale};
          color: ${theme.colors.textonprimary};
          border-radius: 50%;
          margin-right: 15px;
        }
        .title {
          font-size: 1.2em;
          margin: 0;
        }
        .content {
          position: relative;
          padding: 15px 15px 15px 51px;
        }
        .content:after {
          content: '';
          position: absolute;
          top: 0;
          left: 20px;
          width: 2px;
          background-color: #ccc;
          height: 100%;
        }
      `}</style>
    </>
  );
};

Step.propTypes = {
  children: propTypes.any,
  step: propTypes.string,
  title: propTypes.string,
};

export default Step;
